const env = process.env.VUE_APP_ENV
let baseUrl
if (env === 'production') {
  baseUrl = 'https://imapi.ideamake.cn'
} else {
  baseUrl = 'https://test-api.ideamake.cn' // https://test-api.ideamake.cn
}
export const apiUrl = baseUrl
export const trackerSocketUrl = 'wss://zeus.ideamake.cn'